export default "__VITE_ASSET__6na7NPXK__"